const topicSelect = document.querySelector('.topic-select');
const orderField = document.querySelector('.order-number');
const dropArea = document.getElementById('drop-area');
const fileInput = document.getElementById('ContactFormFileUpload');
const dropText = document.getElementById('drop-text');

const showForTopics = [
  'Online Orders',
  'Returns & Refunds',
  'Feedback',
  'Gift Cards',
  'Shipping & Delivery',
  'Promotions & Discounts',
];

topicSelect.addEventListener('change', function () {
  const selected = topicSelect.value;

  if (showForTopics.includes(selected)) {
    orderField.classList.remove('hidden');
  } else {
    orderField.classList.add('hidden');
  }
});

document.getElementById('submitContactForm').addEventListener('click', function (e) {
  e.preventDefault();
  const contact_form = document.querySelector('#ContactForm');
  const loading = document.querySelector('.api-data-loading');
  const requiredFields = contact_form.querySelectorAll('[required]');
  const checkbox = contact_form.querySelector('input[name="accept_privacy_policy"]');
  const formData = new FormData(contact_form);
  let valid = true;

  // Reset any previous highlights
  requiredFields.forEach((field) => field.classList.remove('field--error'));

  // Validate required fields
  requiredFields.forEach((field) => {
    if (!field.value.trim()) {
      field.parentElement.classList.add('field__error');
      valid = false;
    }
  });

  if (!valid) {
    alert('Please fill in all required fields.');
    return;
  }

  if (!checkbox.checked) {
    showMessage('Please accept the Privacy policy', 'error');
    return;
  }

  loading.classList.add('loading');

  fetch(`${window.enhanceify.appUrl}/support/contact`, {
    method: 'POST',
    body: formData,
  })
    .then((res) => res.json())
    .then((data) => {
      console.log('data', data);

      if (data.status === 'success') {
        showMessage('Message received. Our team will attend your requirements soon.', 'success');
        contact_form.reset();
        fileInput.value = '';
        dropText.textContent = 'Choose a file or drag and drop here';
      }
    })
    .catch((err) => {
      showMessage('Email address and Subject is required', 'error');
      console.error(err);
    })
    .finally(() => {
      loading.classList.remove('loading');
    });
});

// Drag and Drop area
['dragenter', 'dragover', 'dragleave', 'drop'].forEach((eventName) => {
  dropArea.addEventListener(eventName, (e) => e.preventDefault());
  dropArea.addEventListener(eventName, (e) => e.stopPropagation());
});

['dragenter', 'dragover'].forEach((eventName) => {
  dropArea.addEventListener(eventName, () => {
    dropArea.classList.add('dragover');
  });
});

['dragleave', 'drop'].forEach((eventName) => {
  dropArea.addEventListener(eventName, () => {
    dropArea.classList.remove('dragover');
  });
});

dropArea.addEventListener('drop', (e) => {
  const files = e.dataTransfer.files;
  if (files.length > 0) {
    fileInput.files = files;
    dropText.textContent = files[0].name;
  }
});

// Also show filename when selected manually
fileInput.addEventListener('change', () => {
  if (fileInput.files.length > 0) {
    dropText.textContent = fileInput.files[0].name;
  }
});
